<template>
  <div class="container-fluid">  
    <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
    <div class="flex-center-center">
      <div class="card col-12 col-xl-10 col-xxl-8 height-responsive">
        <div class="card-header" >
          Espace Fournisseur Agap'Pro - AMi2 par Entegra - Mercuriale comparative
        </div>
        <div class="card-container height-responsive-body height-responsive-1b">
          <div class="card-body">
            <section id="sectionPrincipale">
              <div class="header header-tertiary">Présentation de la page</div>
              <p>Cette page vous permet de gérer vos propositions de tarifs pour une date d'application donnée.</p>  
              <div class="container mb-3">
                <img class="border-black border-rounded w-100" src="../../assets/images/documentation/propositionMercuComparative/mercurialeComparative.png" alt="Image Saisie Proposition pour mercuriale comparative">
              </div>
              <p><span class="bold600">Section 1</span>: Dans la barre du haut, de gauche à droite, vous trouverez les éléments suivants :</p>
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/propositionMercuComparative/Barre_Filtre_MercuComparative.png" alt="Image barre des filtres pour la saisie des propositions">
              <p>
              <ul class="puces">
                <li>La liste des dates d'applications est gérée par le service Achats. Elle comprend les dates d'appel d'offres ainsi que les dates de mises à jour trimestrielles. Si vous avez besoin d'effectuer des mises à jour exceptionnelles pour une date précise, veuillez envoyer un courriel au service Achats pour demander l'ouverture de la date ainsi que la ou les familles concernées.</li>
                <li>La liste des familles contient les familles pour lesquelles nous attendons une mise à jour des tarifs. Comme pour les dates, si une famille n'apparaît pas dans la liste, veuillez vous rapprocher du service Achats.</li>
                <li>La liste des statuts de propositions permet de filtrer les lignes de produits en fonction de leur statut.</li>
                <li>La zone de recherche permet de chercher un ou plusieurs produits.</li>
                <li>La case à cocher "Afficher historique" vous permet de visualiser l'historique de vos propositions sur tous les produits pour la date et la famille sélectionnées.</li>
              </ul>
              </p>
              <p><span class="bold600">Section 2</span>: Dans la barre d'action, de gauche à droite, vous trouverez les éléments suivants :</p>
              <img class="border-black border-rounded w-100" src="../../assets/images/documentation/propositionMercuComparative/Barre_Actions_MercuComparative.png" alt="Image barre d'actions pour la saisie des propositions">
              <p><ul class="puces">
                <li>Exporter [nom famille] : Permet d'exporter la trame de cotation, au format Excel, pour la famille sélectionnée ou de toutes les familles si aucune famille n'est sélectionnée.</li>
                <li>Importer Propositions : Pour importer la trame de cotation renseignée avec vos tarifs.</li>
                <li>Contrôler les liens de fiches techniques : Pour relancer le contrôle des liens de fiches techniques envoyés via le fichier Excel de cotation si ceux-ci sont en erreur.</li>
                <li>Importer FT : Pour importer les fiches techniques des articles de vos propositions dans la famille sélectionnée. Cela peut être un fichier ZIP avec des fichiers PDF ayant comme nom la référence de l'article, ou un fichier PDF avec comme nom la référence de l'article.</li>
                <li>Envoyer les propositions [nom Famille] : permet d'envoyer vos propositions tarifaires de la famille au service Achats.</li>
                <li>Annuler : Annule toutes les modifications en cours faites sur le tableau des propositions.</li>
                <li>Enregistrer : Enregistre les modifications en cours faites sur le tableau des propositions.</li>
              </ul>
              </p>
              <p><span class="bold600">Section 3</span>: Le tableau de vos propositions sur la famille sélectionnée :</p>
              <p>Les produits, unités de besoin, sont triés par catégorie / sous-catégorie.
              Pour chaque unité de besoin, vous allez retrouver votre article avec le tarif actuel et une zone de saisie pour répondre avec un nouveau tarif ou un nouvel article.
              La ligne de saisie reprend la couleur du statut de la proposition tarifaire :
              </p>
              <ul class="puces">
                <template v-for="(statut, iStatut) in listeStatuts">
                  <li :key="'LigneStatut' + iStatut"><span :style="'background-color:' + couleurHexCss(statut.codeCouleur, 25)" class="mr-2">{{ statut.designationFournisseur }}</span>{{ statut.description }}</li>
                </template>
              </ul>
              <p>La raison d'une proposition refusée sera indiquée dans une ligne en dessous des zones de saisie.</p>
              <p>Vous ne pouvez pas modifier les lignes quand elles sont à valider ou validées. Elles sont présentes à titre informatif.</p>
              <p>Certaines zones de saisie peuvent être obligatoires, dans ce cas, un point d'exclamation rouge <i class="fas fa-exclamation text-danger ml-1 mr-1"></i>apparaît à côté de la zone si aucune valeur n'est saisie.</p>
              <p>Toutes données modifiées, une fois enregistrées, seront affichées en <b>gras</b> dans le tableau.</p>
              <p>A droite de chaque ligne, les actions suivantes sont possibles via les boutons :</p>
              <table class="table table-bordered text-center">
                <thead class="table-header">
                  <th>Bouton</th>
                  <th class="aligner-gauche">Signification</th>
                </thead>
                <tbody>
                  <tr>
                    <td><button class="btn btn-primary btn-sm mr-2"><i class="fas fa-eye"></i></button></td>
                    <td class="aligner-gauche">Visualiser la fiche technique attachée à la proposition</td>
                  </tr>
                  <tr>
                    <td><button class="btn btn-primary btn-sm mr-2"><i class="fas fa-upload"></i></button></td>
                    <td class="aligner-gauche">Mettre à jour la fiche technique pour cet article, le fichier doit etre au format PDF.</td>
                  </tr>
                  <tr>
                    <td><button class="btn btn-danger btn-sm mr-2"><i class="fas fa-trash"></i></button></td>
                    <td class="aligner-gauche">Vide la proposition pour cette unité de besoin.</td>
                  </tr>
                  <tr>
                    <td><button class="btn btn-primary btn-sm mr-2"><i class="fas fa-clone"></i></button></td>
                    <td class="aligner-gauche">Duplique les données du tarif actif sur la proposition, hors prix.</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section id="sectionSaisiePropositions">
              <div class="header header-tertiary">Détail du tableau de saisie des propositions.</div>
              <p>Les valeurs à saisir pour répondre à une demande de tarif sont les suivantes :</p>
              <table class="table table-bordered text-center">
                <thead class="table-header">
                  <th>Nom du champ</th>
                  <th class="aligner-gauche">Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Désignation</td>
                    <td class="aligner-gauche">C'est votre désignation du produit. Elle est censée donner plus d'informations à nos adhérents sur la nature du produit.</td>
                  </tr>
                  <tr>
                    <td>Réf.</td>
                    <td class="aligner-gauche">C'est la référence du produit.</td>
                  </tr>
                  <tr>
                    <td>Marque</td>
                    <td class="aligner-gauche">Cela correspond à la marque du produit. Attention, pour la famille "Fruits & Légumes Frais", ce champ sert à indiquer l'origine du produit. Dans le cas où nous demandons un produit d'origine française, c'est à dire un produit dont la désignation contient "(FR)", le champ "marque" doit contenir FRANCE, FRANCAISE, FR ou FRA.</td>
                  </tr>
                  <tr>
                    <td>Prix HT / UC</td>
                    <td class="aligner-gauche">C'est le prix hors taxe par unité de cotation. Attention, votre unité de facturation peut être différente de notre unité de cotation. Veillez à faire la conversion.</td>
                  </tr>
                  <tr>
                    <td>PCB</td>
                    <td class="aligner-gauche">Combien il y a d'unité de cotation dans votre unité de facturation. correspond au par combien</td>
                  </tr>
                  <tr>
                    <td>Unité Fact.</td>
                    <td class="aligner-gauche">Votre unité de facturation.</td>
                  </tr>
                  <tr>
                    <td>Prix UF</td>
                    <td class="aligner-gauche">Champ non saisisable, calcul votre prix à l'unité de facturation en fonction du nombre d'UC par UF (PCB). Cela vous permet de vérifier si la saisie du champ PCB est correcte par exemple.</td>
                  </tr>
                  <tr>
                    <td>UC EDI</td>
                    <td class="aligner-gauche">C'est l'unité de commande pour les commandes passées via EDI, elle peut etre différente de votre unité de Facturation, mais le Prix à l'UC EDI sera identique au prix à l'UF</td>
                  </tr>
                  <tr>
                    <td>Prix UC EDI</td>
                    <td class="aligner-gauche">Champ non saisisable, calcul votre prix par unité de commande EDI</td>
                  </tr>
                  <tr>
                    <td>Commentaire</td>
                    <td class="aligner-gauche">Commentaire destiné au service Achats, peut être obligatoire pour répondre à un refus par exemple.</td>
                  </tr>
                  <tr>
                    <td>FT</td>
                    <td class="aligner-gauche">Pour visualiser ou mettre à jour la fiche technique de votre produit.</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section id="sectionImportPropositions">
              <div class="header header-tertiary">Export/Import des propositions.</div>
              <p>L'export consiste à télécharger une archive qui contient le ou les fichiers de cotations. Si vous n'avez pas sélectionné de famille, l'archive contiendra un fichier par famille attendue, sinon un seul fichier de la famille sélectionnée.</p>
              <p>Le fichier Excel de la famille va reprendre les colonnes présentes à l'écran. Les colonnes à remplir sont celles qui vont de D à N.</p>
              <p>Le fichier exporté ne contiendra que les lignes des unités de besoin pour lesquelles le service Achats attend un tarif.<br/>
                 Pendant la négociation, le fichier ne contiendra que les lignes refusées tant qu'il y en a.<br/>
                 Lorsque toutes les propositions seront validées, l'export reprendra toutes les unités de besoin avec vos tarifs validés.</p>
              <p>La partie de droite contient votre cotation en vigueur, il ne sert à rien de modifier cette partie. Elle est ignorée lors de l'import, elle vous sert juste d'information.</p>
              <p>Le résultat de l'importation du fichier sera visible directement sur la page.</p>
              <p>Voici le détail des champs :</p>
              <table class="table table-bordered text-center">
                <thead class="table-header">
                  <th>Colonne</th>
                  <th>Nom du champ</th>
                  <th class="aligner-gauche">Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>D</td>
                    <td>MARQUE</td>
                    <td class="aligner-gauche">Cela correspond à la marque du produit. Attention, pour la famille "Fruits & Légumes Frais", ce champ sert à indiquer l'origine du produit. Dans le cas où nous demandons un produit d'origine française, c'est à dire un produit dont la désignation contient "(FR)", le champ "marque" doit contenir FRANCE, FRANCAISE, FR ou FRA.</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>REFERENCE</td>
                    <td class="aligner-gauche">C'est la référence du produit.</td>
                  </tr>
                  <tr>
                    <td>F</td>
                    <td>PCB</td>
                    <td class="aligner-gauche">Combien il y a d'unité de cotation dans votre unité de facturation.</td>
                  </tr>
                  <tr>
                    <td>G</td>
                    <td>PRIX HT A L'UC</td>
                    <td class="aligner-gauche">C'est le prix hors taxe par unité de cotation. Attention, votre unité de facturation peut être différente de notre unité de cotation. Veillez à faire la conversion.</td>
                  </tr>
                  <tr>
                    <td>H</td>
                    <td>UF</td>
                    <td class="aligner-gauche">Votre unité de facturation.</td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>PRIX HT AU PCB</td>
                    <td class="aligner-gauche">Champ calculé, non saisisable, calcul votre prix à l'unité de facturation en fonction du nombre d'UC par UF (PCB). Cela vous permet de vérifier si la saisie du champ PCB est correcte par exemple.</td>
                  </tr>
                  <tr>
                    <td>J</td>
                    <td>UC EDI</td>
                    <td class="aligner-gauche">C'est l'unité de commande pour les commandes passées via EDI, elle peut etre différente de votre unité de Facturation, mais le Prix à l'UC EDI sera identique au prix à l'UF</td>
                  </tr>
                  <tr>
                    <td>K</td>
                    <td>PRIX HT UC EDI</td>
                    <td class="aligner-gauche">Prix par unité de commande EDI. Doit etre égale au prix HT à l'UC.</td>
                  </tr>
                  <tr>
                    <td>L</td>
                    <td>DESIGNATION</td>
                    <td class="aligner-gauche">C'est votre désignation du produit. Elle est censée donner plus d'informations à nos adhérents sur la nature du produit.</td>
                  </tr>
                  <tr>
                    <td>M</td>
                    <td>LIEN FICHE TECH.</td>
                    <td class="aligner-gauche">Dans le cas où vos fiches techniques de produits sont disponibles directement en ligne, vous devez mettre dans cette case, l'url qui permet d'y accéder. Il n'y a pas besoin de faire de lien hypertexte, l'url seule suffit. Dans le cas où ces documents ne sont pas en ligne, il faudra les importer manuellement après l'import.</td>
                  </tr>
                  <tr>
                    <td>N</td>
                    <td>COMMENTAIRE</td>
                    <td class="aligner-gauche">Commentaire destiné au service Achats, peut être obligatoire pour répondre à un refus par exemple.</td>
                  </tr>
                  <tr>
                    <td>O</td>
                    <td>RAISON REFUS</td>
                    <td class="aligner-gauche">Champ non saisisable, Raison du refus par le service achats de votre proposition.</td>
                  </tr>
                </tbody>
              </table>
            </section>
            <section id="sectionImportFT">
              <div class="header header-tertiary">Importation des fiches techniques.</div>
              <p>Si vous avez renseigné des liens HTTP dans le fichier de cotation, lors de l'import de celui-ci, un controle est réalisé sur chacun des liens pour vérifier qu'ils sont bien valides.<br/>
                 Si des liens sont en erreurs, le message sera affiché sur chaque ligne de proposition. Vous pouvez relancer le contrôle des liens via le bouton <button class="btn btn-primary btn-sm mr-2">Contrôler les liens de fiches techniques</button><br/>
                 Si le message d'erreur indique une erreur de format du lien HTTP, vous pouvez, soit re-importer un fichier de cotation avec les liens corrigés, soit importer les fiches techniques via les différentes méthodes détaillées ici.
              </p>
              <p>Après avoir fini de créer vos propositions, vous pouvez ajouter des fiches techniques en masse liées à vos propositions.<br/>
                 Pour cela, il vous suffit de cliquer sur le bouton "Importer FT",  puis de charger un fichier ZIP contenant tous les documents PDF.<br/>
                 <span class="danger"><i class="fas fa-exclamation-triangle text-danger"></i> Le fichier ZIP ne doit pas dépasser 100 Mo.</span><br/>
                 Les fichiers PDF doivent avoir un nom qui correspond à la référence du produit à laquelle vous voulez associer la fiche technique. De plus, ces fichiers doivent être directement à la racine de l'archive, il ne doit pas y avoir de sous-dossier.</p>
              <p>Le résultat de l'import sera affiché sur une fenêtre avec le résultat, succès ou échec, pour chaque fichier PDF. En cas d'échec, un message d'erreur sera visible.</p>
              <p>Il est également possible d'importer une fiche technique sur une ligne de proposition, via le bouton <button class="btn btn-primary btn-sm mr-2"><i class="fas fa-upload"></i></button>.<br/>
                 Le fichier doit être au format PDF, peu importe son nom, il sera automatiquement rattaché à la référence de la proposition.</p>
              <p>Chaque fiche technique est visualisable, une fois importée, via le bouton <button class="btn btn-primary btn-sm mr-2"><i class="fas fa-eye"></i></button><br/>Si aucune fiche technique n'est rattachée à votre proposition, ce bouton permet de visualiser la fiche technique du tarif actif.</p>
              
            </section>
            <section id="sectionEnvoyer">
              <div class="header header-tertiary">Envoyer les propositions.</div>
              <p>Quand vous aurez terminé de préparer toutes vos propositions, il va falloir les envoyer au service achats pour validation.<br/>
                 Pour cela, il faut cliquer sur le bouton "Envoyer les propositions".<br/>
                 Si une famille est sélectionnée, les propositions de cette famille seront envoyées, sinon toutes les propositions de toutes les familles disponibles seront envoyées.<br/>
                 Pour pouvoir envoyer les propositions, il faut que :
              </p>
              <p><ul class="puces">
                <li>Tous les champs obligatoires doivent être renseignés.</li>
                <li>Aucune référence ne doit être en doublon sur l'ensemble de vos propositions.</li>
                <li>Une fiche technique doit être associée à tous les nouveaux produits.</li>
              </ul>
              </p>
            </section>
            <section id="sectionFAQ">
              <div class="header header-tertiary">Questions fréquentes.</div>
              <p>
                <ul class="puces">
                  <li><b>Comment exporter les trames de cotations ?</b></li>
                  <p>Vous pouvez exporter les trames de cotations de deux façons différentes.<br/>
                     Si vous ne sélectionnez aucune famille, le bouton d'export permet d'exporter toutes les familles demandées (fig 1).<br/> 
                     Si vous sélectionnez une famille dans la barre de filtre pour une date donnée, vous allez exporter la trame de cette famille (fig. 2).<br/>
                  </p>
                  <img class="border-black border-rounded w-auto mr-2" src="../../assets/images/documentation/propositionMercuComparative/exporter_Toutes_Familles.png" alt="Image barre d'actions pour exporter toutes les familles"><br/>
                  <br/>
                  <img class="border-black border-rounded w-auto" src="../../assets/images/documentation/propositionMercuComparative/exporter_Une_Famille.png" alt="Image barre d'actions pour exporter une famille">
                  <br/>
                  <br/>
                  <li><b>Comment envoyer les fiches techniques ?</b></li>
                  <p>
                    Il existe plusieurs méthodes pour rattacher vos fiches techniques à vos propositions de tarifs.<br/>
                    <ul>
                      <li>A partir du bouton "Importer FT", vous pouvez importer vos fiches techniques à partir d'un fichier ZIP.</li>
                      <span class="danger"><i class="fas fa-exclamation-triangle text-danger"></i>Ce fichier ne doit pas excéder 100 Mo.</span><br/>
                      Le fichier ZIP doit contenir les fiches techniques au format PDF, ces fichiers PDF doivent avoir comme nom la référence du produit.
                      <li>Sur chaque ligne de proposition, via le bouton <button class="btn btn-primary btn-sm mr-2"><i class="fas fa-upload"></i></button>, vous pouvez attacher une fiche technique à la référence de la proposition.</li>
                      Le fichier doit être au format PDF, il ne doit pas excéder 100 Mo.<br/>
                      Le nom du fichier n'a pas d'importance, il sera automatiquement associé à la référence de la proposition.
                      <li>A partir du fichier Excel de cotation, il suffit de renseigner le lien HTTP vers la fiche technique de la référence. Lors de l'import on controlera si ce lien est valide.</li>
                    </ul>
                  </p>
                  <li><b>Quelles sont les informations à remplir dans le fichier de cotation ?</b></li>
                  <p>
                    Le fichier de cotation vous permet d'importer tous vos tarifs pour une famille spécifique directement.<br/>
                    Dans ce fichier, vous devez saisir des informations uniquement sur les colonnes de D à N.<br/>
                    Plus d'informations sur le chapitre <a href="#sectionImportPropositions">Export/Import des propositions.</a>
                  </p>
                </ul>
              </p>
            </section>
          </div>
        </div>
      </div>     
    </div>
  </div>
</template>
  
<script>

import BarreFiltres from '@/components/Divers/BarreFiltres'
import { obtenirStatutsPropositions } from '@/api/gpao/propositions'
import { couleurHexCss } from '@/helpers/utils'

export default {
  name: "AideGenerale",
  components: {
    BarreFiltres
  },
  data() {
    return {
      listeStatuts: [],
      filtres: {
        sections: {
          label: "Choix de votre recherche...",
          champ: "select",
          options: [           
            { valeur: 'sectionPrincipale', texte: 'Présentation de la page' },
            { valeur: 'sectionSaisiePropositions', texte: 'Saisie des propositions' },
            { valeur: 'sectionImportPropositions', texte: 'Export/Import des propositions' },
            { valeur: 'sectionImportFT', texte: 'Import des fiches techniques' },
            { valeur: 'sectionEnvoyer', texte: 'Envoie des propositions' },
            { valeur: 'sectionFAQ', texte: 'Questions fréquentes' },
          ],
          selection: [],
          filtrer(contexte) {
            let filtre = contexte.filtres.sections
            if (filtre.selection) {
              let sectionSelectionnee = document.getElementById(filtre.selection.valeur);
              if (sectionSelectionnee) {
                sectionSelectionnee.scrollIntoView();
              }  
            }            
          }
        },
        // Appeler "this.filtres.initialiser(this)" dans mounted() => génère le tableau de filtres utilisés pour afficher les filtres dans la barre de filtres
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.filtres.barreGauche = [ contexte.filtres.sections ]
        }
      },      
    }
  }, 
  methods: {
    appliquerFiltre(filtrer) {
      // Nécessaire pour faire fonctionner les filtres de la barre de filtres
      filtrer(this)
    },
    couleurHexCss(couleur, pourcentageOpacite) {
      return couleurHexCss(couleur, pourcentageOpacite)
    },
    async chargerStatuts() {
      //Récupère l'ensemble des statuts possible
      let response = await obtenirStatutsPropositions('MCO')
      this.listeStatuts = response.data.filter(s => s.visible)
    },
  },
  mounted() {
    this.filtres.initialiser(this)
    this.chargerStatuts()
  }
}
</script>
  